import React from 'react';

const shimmerKeyframes = `
@keyframes skeleton-shimmer {
  0% { background-position: -200px 0; }
  100% { background-position: calc(200px + 100%) 0; }
}
`;

export function SkeletonBox({ width = '100%', height = '20px', style = {} }) {
  return (
    <div
      style={{
        width, height,
        background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
        backgroundSize: '200px 100%',
        animation: 'skeleton-shimmer 1.5s ease-in-out infinite',
        borderRadius: 'var(--radius-sm)',
        ...style,
      }}
    />
  );
}

export function SkeletonRow({ columns = 1, height = '20px', gap = 'var(--sp-md)' }) {
  return (
    <div style={{ display: 'flex', gap, alignItems: 'center' }}>
      {Array.from({ length: columns }).map((_, i) => (
        <SkeletonBox key={i} height={height} style={{ flex: i === 0 && columns > 1 ? 2 : 1 }} />
      ))}
    </div>
  );
}

export function SkeletonCard({ lines = 3, style = {} }) {
  return (
    <div style={{
      padding: 'var(--sp-xl)', borderRadius: 'var(--radius-md)',
      backgroundColor: 'var(--color-white)', boxShadow: 'var(--shadow-md)',
      ...style,
    }}>
      <SkeletonBox width="60%" height="18px" style={{ marginBottom: 'var(--sp-lg)' }} />
      {Array.from({ length: lines }).map((_, i) => (
        <SkeletonBox
          key={i}
          height="14px"
          style={{ marginBottom: 'var(--sp-md)', width: `${70 + Math.random() * 30}%` }}
        />
      ))}
    </div>
  );
}

export function SkeletonTable({ rows = 5, columns = 4 }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--sp-md)' }}>
      <SkeletonRow columns={columns} height="14px" />
      {Array.from({ length: rows }).map((_, i) => (
        <SkeletonRow key={i} columns={columns} height="12px" />
      ))}
    </div>
  );
}

export default function LoadingSkeleton({ type = 'card', rows, columns, lines }) {
  return (
    <>
      <style>{shimmerKeyframes}</style>
      {type === 'card' && <SkeletonCard lines={lines || 3} />}
      {type === 'table' && <SkeletonTable rows={rows || 5} columns={columns || 4} />}
      {type === 'row' && <SkeletonRow columns={columns || 3} />}
    </>
  );
}
